export class GroupNotificationSubscription {

    constructor(
        public subscribed: boolean,
        public id: number | null,
        public tupleVersion: number | null
      ) {}
}
